import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "@bale/ui/lib/css/index.css";
import "@bale/ui/lib/css/palette.css";
import "@bale/ui/lib/css/shadow.css";

import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/global.scss";

import { Provider } from "react-redux";
import { store, history } from "./utils/store";
import { HistoryRouter as Router } from "redux-first-history/rr6";
import { initSentry } from "sentry";
import { BrowserRouter } from "react-router-dom";

initSentry();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Router history={history}>
        <App />
      </Router>
    </BrowserRouter>
  </Provider>
);
